module.exports = __webpack_public_path__ + "static/media/xk.de260207.svg";